<template>
  <button
    class="button relative"
    :class="buttonClasses"
    :disabled="disabled || loading"
    @click="action"
  >
    <span :class="{ invisible: loading }">
      {{ getReferencelabel(reference) }}
    </span>
    <span
      v-show="loading"
      class="absolute top-0 right-0 bottom-0 left-0 z1 flex items-center justify-center"
    >
      <span class="button-loader"></span>
    </span>
  </button>
</template>

<script>
import { computed } from 'vue';
import { getReferencelabel } from '@/mixins/utils';

export default {
  props: {
    action: {
      type: Function,
      default: () => {}
    },
    reference: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'dark'
    },
    rounded: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const buttonClasses = computed(() => {
      let classes = 'semi-bold';

      if (props.disabled || props.loading) {
        classes += ' opacity-50';
      } else {
        classes += ' pointer';
      }

      if (props.rounded) {
        classes += ' rounded';
      }

      switch (props.color) {
        case 'dark':
          classes += ' border-none white dark-blue-bg';
          break;
        case 'light':
          classes += ' border white-bg dark-blue-border dark-blue';
          break;
        case 'grey':
          classes += ' border-none white grey-bg';
          break;
        default:
          classes += ' border-none white red-bg';
      }

      return classes;
    });

    return {
      getReferencelabel,
      buttonClasses
    };
  }
};
</script>

<style scoped>
.button-loader {
  box-sizing: border-box;
  width: 0.9em;
  height: 0.9em;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid #f3f3f3;
  border-top-color: #3498db;
  animation: loader-spin 0.8s linear infinite;
}

@keyframes loader-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
